import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import debounce from 'lodash/debounce';

const RESIZE_LISTENER_DEBOUNCE_MS = 50;

@Component({
  name: 'CmgFullScreen',
})
export default class CmgFullScreen extends Vue {
  resizeListener: (() => void) | null = null;

  @Prop({ default: true, type: Boolean })
  active!: boolean;

  mounted() {
    this.resize();

    const listener = debounce(() => this.resize(), RESIZE_LISTENER_DEBOUNCE_MS);
    this.resizeListener = listener;

    window.addEventListener('resize', listener);
    document.body.addEventListener('keyup', this.closeModalOnEscapeEventHandler);
    document.addEventListener('keydown', this.tabModalOnFocusEventHandler);
  }

  destroyed() {
    if (this.resizeListener) {
      window.removeEventListener('resize', this.resizeListener);
    }
    document.body.removeEventListener('keyup', this.closeModalOnEscapeEventHandler);
  }

  tabModalOnFocusEventHandler(event: KeyboardEvent) {
    const classCheck = document.getElementsByClassName('fullModal');
    if (classCheck.length > 0) {
      const focusableEls = document.getElementsByClassName('fullModal')[classCheck.length - 1].querySelectorAll('[tabindex="0"]');
      const firstFocusableEl = focusableEls[0] as HTMLElement;
      const lastFocusableEl = focusableEls[focusableEls.length - 1] as HTMLElement;
      if (event.key === 'Tab' && event.shiftKey) {
        if (document.activeElement === firstFocusableEl) {
          event.preventDefault();
          (lastFocusableEl as HTMLElement).focus();
        } // Check for Tab
      } else if (event.key === 'Tab') {
        if (document.activeElement === lastFocusableEl) {
          event.preventDefault();
          (firstFocusableEl as HTMLElement).focus();
        }
      }
    }
  }

  close() {
    this.$emit('close');
    this.$services.ui.focusBack();
  }

  @Watch('active', { immediate: true })
  onActiveUpdated() {
    this.resize();
  }

  private closeModalOnEscapeEventHandler(event: KeyboardEvent) {
    if (event.key == 'Escape') {
      const modalState = this.$appStore.state.ui.modals;
      if (modalState.cancelGroupOrder.visible) {
        this.$services.ui.setModalVisibility('cancelGroupOrder', false);
        this.$services.ui.focusBack();
      } else if (modalState.loyaltyExplainer.visible) {
        this.$services.ui.setModalVisibility('loyaltyExplainer', false);
      } else if (modalState.basicError.visible) {
        this.$services.ui.setModalVisibility('basicError', false);
      } else if (modalState.mealBuilderMealName.visible) {
        this.$services.ui.setModalVisibility('mealBuilderMealName', false);
      } else if (modalState.rewardsCelebration.visible) {
        this.$services.ui.setModalVisibility('rewardsCelebration', false);
        if (this.$appStore.state.ui.bag.visible) {
          this.$services.ui.nextFocus('child-of-order-bag');
        } else {
          const focusNearby = document.getElementsByClassName('customer-greeting')[0] as HTMLElement;
          if (focusNearby) {
            focusNearby.focus();
          }
        }
      } else if (modalState.signIn.visible) {
        this.$services.ui.setModalVisibility('signIn', false);
      } else {
        this.close();
      }
    }
  }

  private resize() {
    const wrapper = this.$refs['wrapper'] as HTMLElement | null;
    if (!wrapper) {
      return;
    }
    const height = window.innerHeight;

    if (!this.active) {
      wrapper.style.height = 'inherit';
      return;
    }

    wrapper.style.height = `${height}px`;
  }
}
